<template>
  <div class="tab p-2v">
    <div v-for="row in rows" :key="row.id" :class="noneValue(row)">
      <row v-for="item in row" :key="item.id" :item="item"
           :width="getWidth(row, item)" :alone="row.length === 1"
      />
    </div>
  </div>
</template>

<script>
import row from '@/components/backoffice/show/tabs/row'

export default {
  components: {
    row
  },

  props: {
    rows: {
      type: Array
    }
  },

  data () {
    return {
      buttons: []
    }
  },

  methods: {
    getWidth: function (row, item) {
      if (item.type === 'longText' || row.length === 1) {
        return 'large'
      } else {
        return 'small'
      }
    },

    noneValue: function (row) {
      for (const item of row) {
        if (item.name === 'custom_field' && !item.value) {
          return 'd-none'
        }
        return 'row border-top'
      }
    }
  }
}
</script>
